// extracted by mini-css-extract-plugin
module.exports = {"formSection":"signup_formSection__aKyI_","heroSection":"signup_heroSection__58Pdt","page":"signup_page__rABjW"};